export class RepairSupplierDistinctMpn {
  MPN: string;
}
